export default __webpack_public_path__ + "static/media/Heavy Pommelin.c908a037.png";